module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki06_sp-c15de41fb862666fcacd048a8476a604.jpg";